const options = {
  5: "bg-stone-800/5",
  10: "bg-stone-800/10",
  25: "bg-stone-800/25",
  50: "bg-stone-800/50",
  75: "bg-stone-800/75",
  90: "bg-stone-800/90",
  100: "bg-stone-800",
};

const from = {
  5: "from-stone-800/5",
  10: "from-stone-800/10",
  25: "from-stone-800/25",
  50: "from-stone-800/50",
  75: "from-stone-800/75",
  90: "from-stone-800/90",
  100: "from-stone-800",
};

export default function getBackgroundStone800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
